import { environment } from 'src/environments/environment';

export class Logger {
    public static log(message?: any, ...optionalParams: any[]): void {
      if (!environment.production) {
        // tslint:disable-next-line: no-console
        console.log('[eos]', message, ...optionalParams);
      }
    }

    public static error(message?: any, ...optionalParams: any[]): void {
      if (!environment.production) {
        // tslint:disable-next-line: no-console
        console.error('[eos]', message, ...optionalParams);
      }
    }
}
